export default {"src":"/_next/static/media/loyalty.a4054493.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};